import { render } from "./NavegacionSuperior.vue?vue&type=template&id=be453c1c&scoped=true"
import script from "./NavegacionSuperior.vue?vue&type=script&lang=js"
export * from "./NavegacionSuperior.vue?vue&type=script&lang=js"

import "./NavegacionSuperior.vue?vue&type=style&index=0&id=be453c1c&scoped=true&lang=css"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\31\\s\\CCD\\hircasa-ccd-webapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be453c1c"]])

export default __exports__